<template>
  <div v-if="productUpdates && productUpdates.length > 0">
    <div
      v-for="(update, index) in productUpdates"
      :key="update.id || index"
      class="relative bg-white rounded-2xl shadow-md p-6 mx-auto mb-4"
    >
      <h3 class="text-lg font-semibold mb-4">Echange de produit</h3>
      <div class="space-y-2">
        <FieldRow label="Reference" :value="update.referenceId" />
        <FieldRow label="Titre" :value="update.title" />
        <FieldRow label="Prix" :value="price(update)" />
        <FieldRow label="Date d'achat" :value="formatAnalyticsDate(update.purchaseDate, 'dd/MM/yyyy')" />
        <FieldRow label="Date de l'échange" :value="formatAnalyticsDate(update.createdAt, 'dd/MM/yyyy')" />
      </div>
    </div>
  </div>
  <div v-else class="text-center text-gray-500 p-6">Aucune mise à jour de contrat disponible</div>
</template>

<script>
import { FieldRow, formatPrice } from "@estaly/ui";
import { formatAnalyticsDate } from "@/utils/date_formatter";

export default {
  components: { FieldRow },
  props: {
    productUpdates: {
      type: Array,
      required: true,
    },
  },

  methods: {
    formatAnalyticsDate,
    price(productUpdate) {
      return `${formatPrice(productUpdate.price)}`;
    },
  },
};
</script>
